import { API } from "aws-amplify";
import { getUnit } from "~/graphql/queries";
import { LoaderData } from "~/types";
import * as APITypes from "~/API";

export const EMPTY_UNIT: APITypes.Unit = {
  id: "",
  status: APITypes.UnitStatusType.None,
  street: "",
  userID: "",
  name: "",
  price: null,
  availabilityDate: "",
  type: "",
  numBedroom: "",
  numBathroom: "",
  size: "",
  buildingID: "",
  tenantID: "",
  contact: "",
  description: "",
  actualRentPaymentDate: "",
  deposit: null,
  additionalFees: null,
  feesDescription: "",
  activeLeaseID: "",
  rent: 0,
  __typename: "Unit",
  createdAt: "",
  updatedAt: "",
  _version: 0,
  _lastChangedAt: 0,
};

export const getUnitDetails = async (
  id?: string
): Promise<LoaderData<APITypes.Unit>> => {
  try {
    const response = (await API.graphql({
      query: getUnit,
      variables: {
        id: id,
      },
    })) as { data?: APITypes.GetUnitQuery };

    return {
      success: true,
      data: response.data?.getUnit ?? EMPTY_UNIT,
    };
  } catch (error) {
    console.error("Error getting unit", error);
    return {
      success: false,
      data: EMPTY_UNIT,
      error,
    };
  }
};
